'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var $offCanvas = $('[data-offcanvas]');
    var activeClass = 'is-active';
    var $html = $('html');
    var $cartDrawer = $('#CartDrawer');
    var $menuDrawer = $('#MenuDrawer');
    $('[data-off-canvas-toggle]').on('click', function (event) {
        event.preventDefault();
        var $clicked = $(event.currentTarget);
        var isCart = $clicked.hasClass('cart-button');
        $offCanvas.addClass('offcanvas-overlap-left');
        $html.css('overflow', 'hidden');
        $cartDrawer.toggle(isCart);
    });
    $('[data-off-canvas-close]').on('click', function (event) {
        event.preventDefault();
        $offCanvas.removeClass('offcanvas-overlap-left');
        $html.css('overflow', 'auto');
    });
    $('[data-off-menu-toggle]').on('click', function (event) {
        event.preventDefault();
        var $clicked = $(event.currentTarget);
        var isMenu = $clicked.hasClass('mobile-nav-button');
        $offCanvas.addClass('offcanvas-overlap-right');
        $html.css('overflow', 'hidden');
        $menuDrawer.toggle(isMenu);
    });
    $('[data-off-menu-close]').on('click', function (event) {
        event.preventDefault();
        $offCanvas.removeClass('offcanvas-overlap-right');
        $html.css('overflow', 'auto');
    });

    // $('#MenuDrawer .has-submenu > a').on('click', (event) => {
    //     event.preventDefault();
    //     $(event.currentTarget).parent().toggleClass(activeClass);
    // });
};